import { render, staticRenderFns } from "./StpAccountInfoMinimal.vue?vue&type=template&id=a8db2612&"
import script from "./StpAccountInfoMinimal.vue?vue&type=script&lang=js&"
export * from "./StpAccountInfoMinimal.vue?vue&type=script&lang=js&"
import style0 from "./StpAccountInfoMinimal.vue?vue&type=style&index=0&id=a8db2612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports